import { Column, TableWithPagination, usePaginatedTable } from "@shared/primitive-components"
import { useMemo } from "react"
import { ResolvedFleetEntry } from "../../../../api/fleet"
import { buildMaybeObfuscatedHeader } from "../../../../components/Obfuscated"

export const UNCHANGED_ENTRIES_TABLE_DATA_TEST_ID = `unchanged_entries`

const BlankCell = () => <div />

type Props = {
  unchangedEntries: ReadonlyArray<ResolvedFleetEntry>
}

export const UnchangedEntriesTable = ({ unchangedEntries }: Props) => {
  const { page, dataCount, pagination } = usePaginatedTable(unchangedEntries)

  const columns = useMemo<ReadonlyArray<Column<ResolvedFleetEntry>>>(
    () => [
      buildMaybeObfuscatedHeader<ResolvedFleetEntry>(`registrationNumber`, `Registration`, { type: `vrn` }),
      {
        Header: `Make`,
        accessor: `make`,
      },
      {
        Header: `Model`,
        accessor: `model`,
      },
      {
        Header: ``,
        id: `blank1`,
        Cell: BlankCell,
      },
      {
        Header: ``,
        id: `blank2`,
        Cell: BlankCell,
      },
    ],
    []
  )

  return (
    <TableWithPagination<ResolvedFleetEntry>
      data={page}
      dataTestIds={{ table: { root: UNCHANGED_ENTRIES_TABLE_DATA_TEST_ID } }}
      dataCount={dataCount}
      pagination={pagination}
      columns={columns}
    />
  )
}
